import React from 'react';
import './NoResults.scss';



const NoResults = ({ params }) => {
    return (
        <div className="noResults">
            <p className="noResults-title">Lo sentimos, no hemos encontrado resultados para <br />
                {params.specialty && params.state && <>“<span>{params.specialty}</span>” y “<span>{params.state}</span>”</> }
                {params.specialty && !params.state && <>“<span>{params.specialty}</span>”</> } 
                {!params.specialty && params.state && <>“<span>{params.state}</span>”</>}
                
            </p>
            <p className="noResults-subtitle">Te sugerimos intentar nuevamente con otros parámetros de búsqueda</p>
        </div>
    );
};

export default NoResults;